import { IDocumentState } from 'types';

export const initState: IDocumentState = {
  isDocumentsLoading: false,
};
